import { render, staticRenderFns } from "./ResourceRow.vue?vue&type=template&id=205fcd1b&scoped=true"
import script from "./ResourceRow.vue?vue&type=script&lang=js"
export * from "./ResourceRow.vue?vue&type=script&lang=js"
import style0 from "./ResourceRow.vue?vue&type=style&index=0&id=205fcd1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205fcd1b",
  null
  
)

export default component.exports